export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Options-Gray-6021993d373d782cd1433c53a61a3bb6.svg";